import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PersonnelRoutingModule } from './personnel-routing.module';
import { ManageUsersComponent } from './manage-users/manage-users.component';
import { ViewLogInsComponent } from './view-log-ins/view-log-ins.component';
import { UserDocMappingComponent } from './user-doc-mapping/user-doc-mapping.component';
import { HomeModule } from '../home/home.module';
import { AddUsersComponent } from './add-users/add-users.component';
import { SearchUsersComponent } from './search-users/search-users.component';
import { AssignDocumentComponent } from './assign-document/assign-document.component';

import { MatGridListModule } from '@angular/material/grid-list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { PendingUsersComponent } from './pending-users/pending-users.component';
import { BulkUpdateUsersComponent } from './bulk-update-users/bulk-update-users.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ViewUserDocComponent } from './view-user-doc/view-user-doc.component';
import { AddCommissionDocComponent } from './add-commission-doc/add-commission-doc.component';

import { MatRadioModule } from '@angular/material/radio';
import { MatTableModule } from '@angular/material/table';
import { NotificationModule } from '../notification.module';
import { NotificationService } from '../service/notification.service';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MaterialModule } from '../material/material.module';
import { NewUsersComponent } from './new-users/new-users.component';

@NgModule({
  declarations: [ManageUsersComponent,
    ViewLogInsComponent, UserDocMappingComponent,
    AddUsersComponent, SearchUsersComponent, AssignDocumentComponent, PendingUsersComponent, BulkUpdateUsersComponent, ViewUserDocComponent, AddCommissionDocComponent, NewUsersComponent],
  imports: [
    CommonModule,
    PersonnelRoutingModule,
    HomeModule,
    MatGridListModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatTableModule,
    NotificationModule,
    MatTabsModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    MatMenuModule,
    MatSortModule,
    MatPaginatorModule,
    MaterialModule
  ],
  providers: [NotificationService]
})
export class PersonnelModule { }
